module.exports = __webpack_public_path__ + "static/media/tw-color.d301f7fb.svg";